import { Button } from '@querodelivery/uni-react';
import { TableEmptyState } from '@/_components/table-empty-state/table-empty-state';
import styles from './empty-state.module.scss';

type MonitorEmptyStateProps =
  | { variant: 'empty' }
  | { variant: 'noSearchResult'; code: string; onClearSearch: () => void }
  | { variant: 'error'; onRetry: () => void };

const getContent = (props: MonitorEmptyStateProps) => {
  switch (props.variant) {
    case 'noSearchResult':
      return {
        title: 'Nenhuma entrega encontrada',
        description: `Não encontramos entregas para o código ${props.code}.`,
        action: { label: 'Limpar busca', onClick: props.onClearSearch },
      };
    case 'error':
      return {
        title: 'Não foi possível carregar as entregas',
        description: 'Tente novamente em alguns instantes.',
        action: { label: 'Tentar novamente', onClick: props.onRetry },
      };
    default:
      return {
        title: 'Nenhuma entrega no momento',
        description: 'Não há entregas neste momento, retorne mais tarde.',
      };
  }
};

export function MonitorEmptyState(props: MonitorEmptyStateProps) {
  const { title, description, action } = getContent(props);

  return (
    <TableEmptyState
      title={title}
      description={description}
      action={
        action ? (
          <Button
            type="button"
            variant="outline"
            className={styles.action}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        ) : null
      }
    />
  );
}
